// Authenticated file download. Ported from siro, adapted for sirov2's
// cookie-based auth: siro sent an `Authorization: Bearer` header (Telegram
// token); here the session cookie rides along on the same-origin request, so no
// header is needed. We still fetch-then-blob (rather than a plain <a href>) so
// the save is driven from JS — needed for the HX-Trigger auto-download path and
// for control over the filename.

export async function downloadAuthed(url, btn) {
	if (!url) return
	if (btn) btn.classList.add('htmx-request')
	try {
		const resp = await fetch(url, {credentials: 'same-origin'})

		// GateKeeper 303-redirects expired sessions to /login; fetch follows the
		// redirect, so detect it by the final URL rather than the status.
		if (resp.redirected && resp.url.includes('/login')) {
			goToLogin()
			return
		}
		if (!resp.ok) {
			console.error('downloadAuthed: request failed', resp.status)
			if (resp.status === 401) goToLogin()
			return
		}

		const blob = await resp.blob()
		const cd = resp.headers.get('content-disposition') || ''
		const match = cd.match(/filename="?([^"]+)"?/)
		const filename = match ? match[1] : 'download.pdf'

		const objectUrl = URL.createObjectURL(blob)
		const a = document.createElement('a')
		a.href = objectUrl
		a.download = filename
		document.body.appendChild(a)
		a.click()
		a.remove()
		URL.revokeObjectURL(objectUrl)
	} catch (err) {
		console.error('downloadAuthed: error', err)
	} finally {
		if (btn) btn.classList.remove('htmx-request')
	}
}

function goToLogin() {
	const next = window.location.pathname + window.location.search
	window.location.href = '/login?next=' + encodeURIComponent(next)
}

// Auto-download (e.g. the full-settle "Receive ₦X" path) is driven server-side:
// the response OOB-mounts a node whose Alpine x-init calls downloadAuthed. This
// htmx fork has no HX-Trigger response header, so there is no event to listen
// for here — downloadAuthed is just invoked directly from that node.
